import {
  Link,
  MessageBar,
  MessageBarButton,
  MessageBarType,
} from "@fluentui/react";
import useAppInsights from "../Hooks/UseAppInsights";
import { NavType } from "./AppInsights";
import { useDataAccessContext } from "../Contexts/DataAccessContext";

/**
 * Message bar component that is displayed when a user does not have access to the ADO repository.
 */
const ADOAccessErrorMessageBar: React.FC = () => {
  const { trackNavigationEvent } = useAppInsights("ADOAccessErrorMessageBar");
  const { activeAccount } = useDataAccessContext();
  return (
    <MessageBar
      messageBarType={MessageBarType.error}
      actions={
        <MessageBarButton
          href="https://myaccess.microsoft.com/@microsoft.onmicrosoft.com#/access-packages/c1d965ea-2ee3-4c89-9ad0-b60be6bbcd32"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            trackNavigationEvent({
              destination:
                "https://myaccess.microsoft.com/@microsoft.onmicrosoft.com#/access-packages/c1d965ea-2ee3-4c89-9ad0-b60be6bbcd32",
              navType: NavType.External,
              properties: { activeAccount },
            });
          }}
        >
          Request Access
        </MessageBarButton>
      }
      isMultiline={false}
    >
      You do not currently have access to the
      <Link
        href="https://dev.azure.com/msazure/One/_git/AzureUX-Experimentation"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          trackNavigationEvent({
            destination:
              "https://dev.azure.com/msazure/One/_git/AzureUX-Experimentation",
            navType: NavType.External,
            properties: { activeAccount },
          });
        }}
      >
        AzureUX-Experimentation
      </Link>{" "}
      repository. You will not be able to manage experiments until access is
      granted.
    </MessageBar>
  );
};

export default ADOAccessErrorMessageBar;
